<script setup>
import { useFutureStore } from '~/store/future'
import { useStorage } from '@vueuse/core'
import { usePanel } from '~/hooks/panel'

const { placeOrder } = usePanel()
const future = useFutureStore()
const noTips = useStorage('noReverseTips', false)

const data = computed(() => future.modalData.reverse)
const positionConfig = computed(() => future.getPositionConfigByCode(data.value.code, {}, data.value.accountName))
async function reverseOrder() {
  const { posiQty, side, code, accountType } = data.value
  await placeOrder({
    price: '',
    quantity: Math.abs(posiQty * 2),
    side: -side,
    code,
    accountType,
  })
  future.modal.reverse = false
}
</script>

<template>
  <CommonXModal v-model:show="future.modal.reverse" :title="$t('反手')" :ok="reverseOrder" @closed="future.modal.reverse = false">
    <div class="space-y-4">
      <OrdersFuturesPositionInfo class="!font-bold" :data="data" />
      <div class="flex justify-between mt-3">
        <span class="text-textSecondary">{{ $t('当前价格') }}</span>
        <span class="font-medium">{{ fix(future.getOverviewByCode(data.code)?.c, future.getInfo(data.code)?.ps) }} {{ future.getInfo(data.code)?.quote }}</span>
      </div>
      <div class="px-4 py-2 border rounded-lg border-border">
        <div class="flex items-center space-x-1 text-base font-bold">
          <span>{{ data.code }}</span>
          <span :class="{ 'text-buy': data.side === 1, 'text-sell': data.side === -1 }">{{ positionConfig.leverage }}X</span>
          <em class="h-6 px-1 text-sm leading-6 rounded" :class="{ 'text-buy bg-green1': data.side === 1, 'text-sell bg-red1': data.side === -1 }">{{ data.side > 0 ? $t('多') : $t('空') }}</em>
        </div>
        <dl class="mt-2">
          <dt class="text-xs">
            {{ $t('仓位数量') }}
          </dt>
          <dd class="font-medium">
            {{ `${Math.abs(data.realAmount)} ${future.getInfo(data.code).base}` }}
          </dd>
        </dl>
      </div>
      <n-divider>
        <div class="flex items-center justify-center h-6 px-2 text-xs rounded bg-pageTertiary">
          <SvgoCommonArrow class="w-3 h-3 rotate-90" />
          <span>{{ $t('反手开空') }}</span>
        </div>
      </n-divider>
      <div class="px-4 py-2 border rounded-lg border-border">
        <div class="flex items-center space-x-1 text-base font-bold">
          <span>{{ data.code }}</span>
          <span :class="{ 'text-buy': data.side === -1, 'text-sell': data.side === 1 }">{{ positionConfig.leverage }}X</span>
          <em class="h-6 px-1 text-sm leading-6 rounded" :class="{ 'text-buy bg-green1': data.side === -1, 'text-sell bg-red1': data.side === 1 }">{{ data.side > 0 ? $t('空') : $t('多') }}</em>
        </div>
        <dl class="mt-2">
          <dt class="text-xs">
            {{ $t('仓位数量') }}
          </dt>
          <dd class="font-medium">
            {{ `${Math.abs(data.realAmount)} ${future.getInfo(data.code).base}` }}
          </dd>
        </dl>
      </div>
      <!-- <div class="pb-4 border-b text-textSecondary border-border">
        {{ $t('用户最大可开仓的数量') }} = <span class="font-medium text-textPrimary">{{ `${data.realAmount} ${future.getInfo(data.code).base}` }}</span>
      </div> -->
      <div class="text-xs text-textSecondary">
        {{ $t('说明：您的仓位将进行市价平仓，并反向开仓相同数量。如资金不足以开仓相同数量，则按照最大可开数量进行开仓。受保证金、行情等因素的影响，您的操作未必100%成功') }}
      </div>
      <CommonXCheckbox v-model="noTips">
        {{ $t('不再提示,可在"偏好设置"中再次打开') }}
      </CommonXCheckbox>
    </div>
  </CommonXModal>
</template>
